// React
import React from 'react';

// Components
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { ADGMTextField, ADGMDatePicker, ADGMSelect, ADGMAlert, ADGMCalenderField, ADGMPanel } from 'aurora-components';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';

// utils
import { injectIntl } from 'react-intl';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { CommaSeparatedWithoutCurrency } from 'aurora-utils/constants';
import messages from 'aurora-translations';
import { PlainString, keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import format from 'date-fns/format';
import addMonths from 'date-fns/addMonths';
import addDays from 'date-fns/addDays';
import addYears from 'date-fns/addYears';
import PropTypes from 'prop-types';

// Styles
import styles from './styles';

const FormCheckBoxIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='2' y='2' width='20' height='20' fill='white' />
    <g clipPath='url(#clip0_1923_40932)'>
      <path
        d='M19 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.67441 23.9984 5 24H19C20.3256 23.9984 21.5964 23.4711 22.5338 22.5338C23.4711 21.5964 23.9984 20.3256 24 19V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0ZM22 19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V19Z'
        fill='#130F26'
      />
    </g>
    <defs>
      <clipPath id='clip0_1923_40932'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

const CheckedFormCheckBoxIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_1923_12217)'>
      <path
        d='M19 0H5.00002C2.23997 0.00332812 0.00332812 2.23997 0 5.00002V19C0.00332812 21.76 2.23997 23.9967 5.00002 24H19C21.76 23.9967 23.9967 21.76 24 19V5.00002C23.9967 2.23997 21.76 0.00332812 19 0ZM20 8.079L10.746 17.333C9.96511 18.1142 8.69878 18.1145 7.91756 17.3336C7.91738 17.3334 7.91719 17.3332 7.917 17.333L3.99998 13.417C3.60867 13.0257 3.60867 12.3913 3.99998 12C4.3913 11.6088 5.0257 11.6087 5.41697 12L9.33295 15.916L18.588 6.66202C18.9793 6.27211 19.6125 6.27323 20.0025 6.6645C20.3924 7.05581 20.3913 7.68909 20 8.079Z'
        fill='#1FCACC'
      />
    </g>
    <defs>
      <clipPath id='clip0_1923_12217'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

function AgreementDetails(props) {
  const {
    classes,
    intl,
    agreement,
    isPMC,
    isRenewal,
    isAmendment,
    lessThanOneMonth,
    handleChange,
    isPMABank,
    durationError,
  } = props;

  const minimumContractEndDate = startDate => {
    if (startDate) {
      return addDays(addMonths(new Date(startDate), 3), -1);
    }
    return addDays(addMonths(new Date(), 3), -1);
  };

  const maximumContractEndDate = startDate => {
    if (startDate) {
      return addDays(addYears(new Date(startDate), isPMC ? 4 : 2), -1);
    }
    return addDays(addYears(new Date(), 4), -1);
  };

  return (
    <div className={classes.contentArea}>
      <ADGMPanel title='agreement_details'>
        <div className={classNames(classes.innerCardGrid, classes.agreementDetailsinnerCard)}>
          <div className={classes.innerframe}>
            <Hidden mdDown>
              <Typography variant='body1' className={classes.graysubtitle}>
                {keyEmptyCheck('allowed_permissions')}
              </Typography>
            </Hidden>
            <FormGroup row className={classNames(classes.CheckboxHolder, classes.CheckboxcheckedHolder)}>
              <FormControlLabel
                name='rentCollectionBehalfOwner'
                control={
                  <Checkbox
                    checked={agreement.rentCollectionBehalfOwner}
                    icon={<FormCheckBoxIcon />}
                    checkedIcon={<CheckedFormCheckBoxIcon />}
                    onChange={e => handleChange({ rentCollectionBehalfOwner: e.target.checked }, 'agreement')}
                  />
                }
                label={keyEmptyCheck('rent_collection')}
              />
              <FormControlLabel
                name='cancelPmaWithoutBothConsent'
                control={
                  <Checkbox
                    checked={agreement.cancelPmaWithoutBothConsent}
                    icon={<FormCheckBoxIcon />}
                    checkedIcon={<CheckedFormCheckBoxIcon />}
                    onChange={e => handleChange({ cancelPmaWithoutBothConsent: e.target.checked }, 'agreement')}
                  />
                }
                label={keyEmptyCheck('agreement_termination')}
              />
              <FormControlLabel
                name='allowFirstPartyAccess'
                control={
                  <Checkbox
                    checked={agreement.allowFirstPartyAccess}
                    icon={<FormCheckBoxIcon />}
                    checkedIcon={<CheckedFormCheckBoxIcon />}
                    onChange={e => handleChange({ allowFirstPartyAccess: e.target.checked }, 'agreement')}
                  />
                }
                label={keyEmptyCheck('allow_first_party_access')}
              />
            </FormGroup>
          </div>
        </div>
      </ADGMPanel>
      <ADGMPanel title='agreement_duration_amount'>
        <div className={classes.innerCardGrid}>
          {isPMC && (
            <ADGMAlert type='mute' classes={{ container: classes.contractDurationIfo }}>
              {keyEmptyCheck('agreement_duration_amount_hint')}
            </ADGMAlert>
          )}
          <FormControl className={classes.formControl}>
            <div htmlFor='contractStartDate' className={classes.unitinputControl}>
              <ADGMDatePicker
                date={agreement.contStartDate}
                onChange={date => handleChange({ contStartDate: date, contEndDate: null }, 'agreement')}
                disabled={isAmendment || isRenewal}
                component={
                  <ADGMCalenderField
                    value={agreement.contStartDate && format(new Date(agreement.contStartDate || ''), 'dd/MM/yyyy')}
                    id='contractStartDate'
                    name='contractStartDate'
                    placeholder='dd/mm/yyyy'
                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    className={classes.calendarTextfield}
                    variant='outlined'
                    autoComplete='off'
                    label={keyEmptyCheck(isPMABank ? 'issuance_date' : 'start_date')}
                    required
                    disabled={isAmendment || isRenewal}
                    handleInputChange={inDates => {
                      inDates && handleChange({ contStartDate: inDates, contEndDate: null }, 'agreement');
                    }}
                  />
                }
              />
            </div>
            <div htmlFor='contractEndDate' className={classes.unitinputControl}>
              <ADGMDatePicker
                date={
                  agreement.contEndDate
                    ? agreement.contEndDate
                    : isPMC
                    ? minimumContractEndDate(agreement.contStartDate)
                    : new Date()
                }
                onChange={date => handleChange({ contEndDate: date }, 'agreement')}
                disabled={!agreement.contStartDate || (!lessThanOneMonth && isAmendment)}
                lowerLimit={minimumContractEndDate(agreement.contStartDate)}
                upperLimit={maximumContractEndDate(agreement.contStartDate)}
                required
                component={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <ADGMCalenderField
                    value={agreement.contEndDate && format(new Date(agreement.contEndDate || ''), 'dd/MM/yyyy')}
                    id='contractEndDate'
                    name='contractEndDate'
                    placeholder='dd/mm/yyyy'
                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    className={classes.calendarTextfield}
                    variant='outlined'
                    autoComplete='off'
                    disabled={!agreement.contStartDate || (!lessThanOneMonth && isAmendment)}
                    required
                    label={keyEmptyCheck('end_date')}
                    lowerLimit={minimumContractEndDate(agreement.contStartDate)}
                    upperLimit={maximumContractEndDate(agreement.contStartDate)}
                    handleInputChange={inDates => {
                      inDates && handleChange({ contEndDate: inDates }, 'agreement');
                    }}
                  />
                }
              />
            </div>
          </FormControl>
          {durationError && (
            <div className={classes.informationMessage}>
              <ADGMAlert type='error' classes={{ container: classes.adgmAlert }}>
                <span className={classes.adgmBlackText}>
                  {keyEmptyCheck('Start date and end date should be within the possessory mortgage start & end date')}
                  &nbsp;
                  <Link href='#'>{keyEmptyCheck('link content')}</Link>
                </span>
              </ADGMAlert>
            </div>
          )}
          {isPMABank && (
            <div className={classes.informationMessage}>
              <ADGMAlert type='info' noBackground>
                <span className={classes.adgmBlackText}>
                  {keyEmptyCheck('Duration should be within the possessive mortgage contract period.')}&nbsp;
                  <Link href='#' color='#004890'>
                    {keyEmptyCheck('link content')}
                  </Link>
                </span>
              </ADGMAlert>
            </div>
          )}
          <FormControl className={classNames(classes.formControl, classes.formControlContract)}>
            <div htmlFor='amountType' className={classes.unitinputControl}>
              <ADGMSelect
                id='amountType'
                name='amountType'
                type='select'
                label={keyEmptyCheck('contract_amount')}
                placeholder=''
                required
                value={agreement.amountType}
                onChange={(name, value) => {
                  handleChange({ [name]: value.value, totalAmount: '' }, 'agreement');
                }}
                options={[
                  { value: 'PERCENTAGE', label: intl.formatMessage({ ...messages.percentage }) },
                  { value: 'AED', label: intl.formatMessage({ ...messages.AED }) },
                ]}
              />
            </div>
            <div htmlFor='totalAmount' className={`${classes.unitinputControl} ${classes.alignGridItemsToBottom}`}>
              {agreement.amountType === 'AED' && (
                <ADGMTextField
                  id='totalAmount'
                  name='totalAmount'
                  mask={createNumberMask(CommaSeparatedWithoutCurrency)}
                  variant='outlined'
                  min={0}
                  max={Number.POSITIVE_INFINITY}
                  placeholder={intl.formatMessage({ ...messages.eg_aed_30000 })}
                  value={agreement.totalAmount}
                  required
                  onChange={e => {
                    handleChange({ totalAmount: PlainString(e.target.value) }, 'agreement');
                  }}
                />
              )}
              {agreement.amountType === 'PERCENTAGE' && (
                <ADGMTextField
                  id='totalAmount'
                  name='totalAmount'
                  variant='outlined'
                  placeholder={intl.formatMessage({ ...messages.eg_20_percent })}
                  min={0}
                  max={100}
                  value={agreement.totalAmount}
                  required
                  onChange={e => {
                    handleChange({ totalAmount: e.target.value }, 'agreement');
                  }}
                />
              )}
            </div>
          </FormControl>

          <div className={classes.informationMessage}>
            <ADGMAlert type='info' noBackground={isPMABank} classes={{ container: classes.adgmAlert }}>
              {isPMABank ? (
                <>
                  <span className={classes.adgmBlackText}>
                    {keyEmptyCheck('Contract amount percentage is the charge rate agreed between both parties')}&nbsp;
                    <Link href='#' color='#004890'>
                      {keyEmptyCheck('link content')}
                    </Link>
                  </span>
                </>
              ) : (
                keyEmptyCheck('contract_amount_percentage_content')
              )}
            </ADGMAlert>
          </div>
        </div>
      </ADGMPanel>
    </div>
  );
}

AgreementDetails.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  agreement: PropTypes.object.isRequired,
  isPMC: PropTypes.bool.isRequired,
  isRenewal: PropTypes.bool.isRequired,
  isAmendment: PropTypes.bool.isRequired,
  lessThanOneMonth: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  isPMABank: PropTypes.bool.isRequired,
  durationError: PropTypes.bool.isRequired,
};

export default withStyles(styles)(injectIntl(AgreementDetails));
